/* eslint-disable max-lines-per-function */
import React, { useRef, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Growl } from 'primereact/growl';
import { Formik } from 'formik';
import { validacaoFormImagens } from '../helpers/validacao';
import { FormCadastrarMidia } from '../components/FormCadastrarMidia';
import { mostrarMensagemSucesso } from '../../shared/getMensagens';

export function EditarMidia({
    rowSelecionada,
    modalEdicaoAberto,
    setModalEdicaoAberto,
    setRecarregarDataTable    
}) {
    const [mensagem, setMensagem] = useState(false);
    const fecharModal = () => setModalEdicaoAberto(false);
    const mensagemToast = useRef(null);
    const initialValues = {
        descricao: rowSelecionada.descricao        
    };

    if(mensagem === true) {
        mostrarMensagemSucesso(mensagemToast,'Midia atualizada com sucesso!');
        setMensagem(false);
    } 
    
    return (
        <div>
            <Growl ref={mensagemToast} />
            <Dialog
                header={'Editar midia'}
                visible={modalEdicaoAberto}
                dismissableMask
                onHide={fecharModal}                
            >              
                <Formik                    
                    initialValues={initialValues}
                    validationSchema={validacaoFormImagens}
                >
                    <FormCadastrarMidia
                        setMensagem={setMensagem} 
                        setRecarregarDataTable={setRecarregarDataTable} 
                        setOpenModalCadastro={setModalEdicaoAberto} 
                        rowSelecionada={rowSelecionada}
                        nomebotao={'Atualizar'}></FormCadastrarMidia>
                </Formik>                
            </Dialog>
        </div>
    );
}
